import React, { useState, useContext, useEffect, startTransition } from "react";
import "../../utils/css/leftDiv.css";
import { Context } from "../../../context/DataProvider";
import { trackEvent } from "../../../config/eventHandlers";
import { getCustomerSupportEmailId } from "../../../utils/constants"
import { ScreenName } from "../../../config/constants";
import dashboardSquareAdd from "../../utils/images/dashboard-square-add.svg";
import iconTimer from "../../utils/images/iconTimer.svg";
import {useTaskDeviceBridge} from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";

const LeftMenuList = [
  {
    id: "summary",
    name: "Summary",
    icon: <img src={dashboardSquareAdd} alt="dashboard-square-add" />,
  },
  {
    id: "your_claims",
    name: "Track Claims",
    icon: <img src={iconTimer} alt="iconTimer" />,
  },
];

export default function LeftDiv() {
  const { setFlag, setTabSwitching } = useContext(Context);
  const taskDeviceBridge = useTaskDeviceBridge();

  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("activeReimbursementTab");
    return savedTab || LeftMenuList[0].id;
  });

  const clickHapticFeedback = async () => {
    try {
      await taskDeviceBridge.getHapticFeedBack("CLICK");
    } catch (error) {
      console.error("Haptic feedback error:", error);
    }
  };

  const handleTabChange = async (id) => {
    await clickHapticFeedback();
    setTabSwitching(true);
    setActiveTab(id);
    localStorage.setItem("activeReimbursementTab", id);
    startTransition(() => {
      if (id === "summary") {
        setFlag(false);
      } else {
        setFlag(true);
      }
    });
  };

  useEffect(() => {
    startTransition(() => {
      if (activeTab === "summary") {
        setFlag(false);
      } else {
        setFlag(true);
      }
    });
  }, [activeTab]);

  return (
    <div>
      <div role="tablist" className="nav-bar-vertical">
        {LeftMenuList.map((i, index) => (
          <div
            key={i.id}
            tabIndex={"0"}
            role="tab"
            aria-label={`${i.name} tab`}
            className={
              activeTab === i.id
                ? "left-nav-item-new left-nav-item-active-new"
                : "left-nav-item-new"
            }
            style={{ width: "100%", borderRadius: "10px" }}
            onClick={() => {
              handleTabChange(i.id);
              if (i.id === "your_claims") trackEvent.yourClaimsClick({ screenName: ScreenName.SUMMARY });
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleTabChange(i.id);
                if (i.id === "your_claims") trackEvent.yourClaimsClick({ screenName: ScreenName.SUMMARY });
              }
            }}
          >
            <div className="left-nav-content">
              <span className="left-nav-icon">{i.icon}</span>
              <span className="left-nav-text"> {i.name}</span>
            </div>
          </div>
        ))}
      </div>
      
        <div className="queries-new">
          <div className="queries-header">
              <b>Need help with Claim?</b>
            </div>
            <div className="queries-content">
              <p>
                If you have any questions or concerns about your OPD claims, just drop us an email at <strong>{getCustomerSupportEmailId()}</strong>. Our support team will get back to you as soon as possible to help you out.
              </p>
            </div>
          </div>
        </div>
  
  );
}
